import React from 'react';
import PropTypes from 'prop-types';

const DateStamp = ({ date }) => {
  return <time className="leading-6">{date}</time>;
};

DateStamp.propTypes = {
  /** date string from frontmatter */
  date: PropTypes.string.isRequired
};

export default DateStamp;
